import React, { cloneElement, useRef } from 'react'
import {
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const Dialog = ({
  trigger,
  title,
  description,
  cancelText,
  acceptText,
  onClose,
  onAccept,
  children,
  ...otherProps
}) => {
  const { isOpen, onOpen, onClose: closeModal } = useDisclosure()
  const triggerRef = useRef()
  const cancelRef = useRef()

  const handleDialogClose = () => {
    closeModal()
    onClose()
  }

  const handleDialogAccept = () => {
    onAccept()
    handleDialogClose()
  }

  return (
    <>
      {cloneElement(trigger, { onClick: onOpen, ref: triggerRef })}
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={handleDialogClose}
        finalFocusRef={triggerRef}
        closeOnOverlayClick={false}
        motionPreset="slideInBottom"
        scrollBehavior="inside"
        {...otherProps}
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>{title}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>{description}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={handleDialogClose}>
              {cancelText}
            </Button>
            <Button colorScheme="red" ml={3} onClick={handleDialogAccept}>
              {acceptText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

Dialog.propTypes = {
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  trigger: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  cancelText: PropTypes.string,
  acceptText: PropTypes.string
}

Dialog.defaultProps = {
  onClose: () => {},
  onAccept: () => {},
  title: 'Confirma actiunea',
  description: 'Doresti sa confirmi actiunea?',
  cancelText: 'Anuleaza',
  acceptText: 'Confirma'
}

export default Dialog
